import React, { useRef, useEffect } from 'react';
import { Modal as ModalB, Row, Col, Button } from 'react-bootstrap';

const Modal = ({ 
  handleClose, 
  show,
  children,
  handleSubmit,
  onSubmit,
  buttonLabel = "Submit"
}) => {

  const submitRef = useRef(null);

  useEffect(() => {
     submitRef.current?.focus();
  }, []);

  return (
    <ModalB show={show} backdrop={true} onHide={handleClose} centered animation={false} keyboard={true}>
      <form  onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            {children}
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="text-right">
            <span
              type="button"
              className="btnSizes transparentBtn border-0"
              onClick={() => handleClose("cancel")}
            >
              Cancel
            </span>
            <button
              ref={submitRef}
              type="submit"
              className='btnSizes filledBtn ml-5'
            >
              {buttonLabel}
            </button>
          </Col>
        </Row>
      </form>
    </ModalB>
  )
}

export default Modal;
